import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    clearSearch,
    clearSearchServiceData,
    resetSearchContext,
} from '../redux/reducers/search/searchData';
import {
    getItemFromLocalStorage,
    setItemToLocalStorage,
} from '../services/network/storage';
import { store } from '../redux';
import { clearAllPaginationStorage } from '../components/lists/Paginate';
import { clearVehicleSearchSessionStorage } from '../utils/common/searchSessionStorage';

export const useStorageKeyWatcher = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const onStorageChange = (e) => {
            if (e.key === 'storageKey') {
                clearVehicleSearchSessionStorage();
                dispatch(clearSearch());
            }
        };

        window.addEventListener('storage', onStorageChange);

        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, [dispatch]);
};

export const resetSearchState = () => {
    clearVehicleSearchSessionStorage();
    store.dispatch(resetSearchContext());
    store.dispatch(clearSearchServiceData());
};

export const setStorageKey = (newKey) => {
    const currentKey = getItemFromLocalStorage('storageKey');

    if (currentKey !== newKey) {
        if (currentKey) {
            resetSearchState();
            clearAllPaginationStorage();
        }

        setItemToLocalStorage('oldStorageKey', currentKey);
        setItemToLocalStorage('storageKey', newKey);
    }
};
